var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20836 1.08337H3.7917C2.29593 1.08337 1.08337 2.29593 1.08337 3.7917V9.20836C1.08337 10.7041 2.29593 11.9167 3.7917 11.9167H9.20836C10.7041 11.9167 11.9167 10.7041 11.9167 9.20836V3.7917C11.9167 2.29593 10.7041 1.08337 9.20836 1.08337Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66658 6.15879C8.73343 6.60959 8.65643 7.06999 8.44653 7.4745C8.23664 7.87902 7.90454 8.20705 7.49746 8.41194C7.09039 8.61683 6.62908 8.68815 6.17914 8.61574C5.7292 8.54334 5.31354 8.33091 4.99129 8.00866C4.66904 7.68641 4.45661 7.27076 4.38421 6.82082C4.31181 6.37088 4.38312 5.90956 4.58802 5.50249C4.79291 5.09542 5.12094 4.76332 5.52545 4.55342C5.92997 4.34353 6.39037 4.26653 6.84117 4.33337C7.301 4.40156 7.72671 4.61583 8.05542 4.94454C8.38412 5.27325 8.59839 5.69895 8.66658 6.15879Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47913 3.52087H9.48626",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b6affe6fb76d21c67f7fde75e12574b1.svg";
export { ForwardRef as ReactComponent };